import Header from "./Header.js";
import About from "./About.js"
import Footer from "./Footer.js"

import React, {useState} from "react";

function Body (props) {
    const [activeTab, setActiveTab] = useState("identity")
    
    return (
        <div>
            <Header isMobile={props.isMobile} activeTab={activeTab} setActiveTab={setActiveTab}/>
            <About />
            <Footer />
        </div>

    )

}

export default Body;